import { gql } from 'graphql-request';

export default gql`
  mutation callflowUpdateById($data: JSON) {
    callflowUpdateById(data: $data) {
      success
      message
      data
    }
  }
`;
